<template>
  <div class="home-content">
  <navbar />

  <div class="fold-container">
    <div class="container hero-container">
      <div class="first-content">
        <div class="intro-tekst">
          <h1>Wij maken <br> merken <span>menselijk</span></h1>
          <p>En houden van digital first branding & product design</p>
        </div>
      </div>

      <div class="case-hightlight-img">
        <div class="intro-animation">
          <div class="animation">
            <lottie :options="headerImages[headerIndex].defaultOptions"/>      
          </div>
          <img :src="headerImages[headerIndex].image">
          <router-link class="router-link" :to="headerImages[headerIndex].link">{{ headerImages[headerIndex].string }}</router-link>
        </div>
      </div>
    </div>
    <div :style="{'background-color':headerImages[headerIndex].background}" class="home-bg-color-change"></div>
  </div>

  <ourMission></ourMission>
  <caseGrid>
    <div class="row">
        <ul>
           
          <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
          <div class="column intro"> 
            <h3>Werk waar we blij van worden.</h3>
            <p>Cases die tot stand zijn gekomen door toevallige ontmoetingen, intense brainstormsessies, passie voor het vak, maar vooral door de toffe mensen waar we mee mogen samenwerken.</p>
          </div>
          </li>

       <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}">   
          <router-link class="router-link" to="/werk/avans-hogeschool">
            <div class="column avans">
              <img src="../assets/Folded_Paper_case_thumbnail_Avans_Hogeschool.jpg">
              <span class="font-size-custom-max-12">Avans Hogeschool<br>Product design</span>
            </div>
          </router-link>
          </li>
                   
        <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}">   
          <router-link class="router-link" to="/werk/newschain">
            <div class="column newschain-2">
              <img src="../assets/Folded_Paper_case_thumbnail_Newschain.jpg">
              <span class="font-size-custom-max-12">Newschain<br>Product design</span>
            </div>
           </router-link>
          </li>

          <li v-scroll-reveal="{ delay: 550, viewFactor: 0.7}">  
          <router-link class="router-link" to="/werk/mobilyze">
          <div class="column mobilyze">  
            <img src="../assets/Folded_Paper_case_thumbnail_Mobilyze.jpg">
            <span class="font-size-custom-max-12">Mobilyze<br>Branding & product design</span>
          </div>
          </router-link>
          </li>

            <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
          <router-link class="router-link" to="/werk/wageningen-universiteit">
          <div class="column unlock">
            <img src="../assets/Folded_Paper_case_thumnail_Unlock.jpg">
            <span class="font-size-custom-max-12">Unlock Wageningen Universiteit & Research <br>Branding & product design</span>
          </div>
          </router-link>
          </li>

          <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
          <router-link class="router-link" to="/werk">
          <div class="column end" id="dotted-column">  
            <p>Klik hier voor meer cases</p>
          </div>
          </router-link>
        </li>

        <li></li>
        
      </ul>
    </div>
  </caseGrid>

  <howWeWork></howWeWork>
  <footerComponent></footerComponent>

    
  </div>
</template>

<script>
import ourMission from '@/components//specificLayout/ourMission.vue';
import caseGrid from '@/components/generalLayout/caseGrid.vue';
import fullBanner from '@/components/generalLayout/fullBanner.vue';
import howWeWork from '@/components/specificLayout/howWeWork.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';

import Lottie from '../lottie.vue';
import * as animationAvansHogeschool from '@/assets/cases/avanshogeschool/headeranimatie/avanshogeschool.json';
import * as animationTeamchangingAcademy from '@/assets/cases/teamchangingacademy/headeranimatie/teamchangingacademy.json';
import * as animationGowallet from '@/assets/cases/gowallet/headeranimatie/gowallet.json';
import * as animationMobilyze from '@/assets/cases/mobilyze/headeranimatie/mobilyze.json';
import * as animationNewschain from '@/assets/cases/newschain/headeranimatie/newschain.json';
import * as animationWageningen from '@/assets/cases/wageningenuniversiteit/headeranimatie/wageningenuniversiteit.json';


import navbar from '@/components/generalLayout/navbar.vue';


import { page } from 'vue-analytics'


export default {
  name: 'helloWorld',

  data () {
    return {
      headerImages: [
	      { defaultOptions: {animationData: animationAvansHogeschool.default}, background: 'rgba(255,30,61,0.15)', link: '/werk/avans-hogeschool', string:'Bekijk de Avans Hogeschool Case', },
	      { defaultOptions: {animationData: animationTeamchangingAcademy.default}, background: 'rgba(68,3,3,0.20)', link: '/werk/team-changing-academy', string:'Bekijk de Team Changing Academy Case', },
        { defaultOptions: {animationData: animationGowallet.default}, background: 'rgba(251,210,118,0.15)', link: '/werk/gowallet', string:'Bekijk de GoWallet Case', },
        { defaultOptions: {animationData: animationMobilyze.default}, background: 'rgba(22,141,0,0.15)', link: '/werk/mobilyze', string:'Bekijk de Mobilyze Case', },
        { defaultOptions: {animationData: animationNewschain.default}, background: 'rgba(173, 227, 245, 0.15)', link: '/werk/newschain', string:'Bekijk de Newschain Case', },
        { defaultOptions: {animationData: animationWageningen.default}, background: 'rgba(82, 51, 132, 0.15)', link: '/werk/wageningen-universiteit', string:'Bekijk de Wageningen Universiteit Case', },
      ],
    }
  },
  components:{
    ourMission,
    caseGrid,
    fullBanner,
    howWeWork,
    navbar,
    footerComponent,
    'lottie': Lottie,
  },

  methods:{
    randomNumber(maxValue){
      return Math.floor(Math.random() * Math.floor(maxValue));
    },
  },
  computed:{
    headerIndex(){
      return this.randomNumber(this.headerImages.length);
    }
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.intro-tekst{
  span{
    color: #E84B5A;
  }
}

@media screen and (max-width: 720px) {
  .content-grid-two-rows{
    .firstenergy, .loud, .newschain, .tca{
      float: none;
    }
  }
}

</style>
